module.exports = __webpack_public_path__ + "img/disconnect.ff867bda.svg";